// Fires Attentive's Back In Stock popup when `.fts-backinstock-btn` is clicked.
(function () {
  'use strict';

  const DESKTOP_MIN_WIDTH = 760;
  const RETRY_DELAY_MS = 500;
  const MAX_ATTEMPTS = 10; // ~5s total, in case the Attentive tag loads slowly.

  function getTriggerArgs(el) {
    const isDesktop = globalThis.innerWidth >= DESKTOP_MIN_WIDTH;

    // Get creative ID based on device type
    const creative = isDesktop
      ? el.dataset.attentiveCreativeDesktop
      : el.dataset.attentiveCreativeMobile;

    // Return array format expected by Attentive's trigger method
    // [filter, clientId, email, creative_id]
    return [null, null, null, creative && /^\d+$/.test(creative) ? Number(creative) : creative];
  }

  function fireTrigger(args, attempt) {
    if (globalThis.__attentive && typeof globalThis.__attentive.trigger === 'function') {
      globalThis.__attentive.trigger(...args);
      return;
    }

    // Attentive tag may not have finished loading yet; retry on a delay.
    if (attempt < MAX_ATTEMPTS) {
      setTimeout(function () {
        fireTrigger(args, attempt + 1);
      }, RETRY_DELAY_MS);
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.fts-backinstock-btn');

    if (!button) return;

    event.preventDefault();
    fireTrigger(getTriggerArgs(button), 0);
  });
})();
